import KeyboardingAPI from '@/api';
import graph from 'src/graph';
import SAVE_STUDENT_SETTING from 'src/graph/mutations/save-student-settings';

export default {
  async getCurriculum({ commit, state }) {
    const { id: studentId, sessionId } = state;

    if (!sessionId) return;

    const {
      status,
      data: { curriculum, bestResults, position }
    } = await KeyboardingAPI.getCurriculum(sessionId);

    const { stopAndReview: { week: stopAndReviewWeek } = {} } = position;

    if (status < 400) {
      commit('setCurriculum', curriculum);
      commit('setStudent', {
        bestResults,
        position,
        stopAndReviewWeek
      });
    } else {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  },
  async saveStudentSettings({ commit, state }) {
    const { id: studentId, accessibilitySettings } = state;

    if (!studentId) return;

    commit('setStudent', {
      accessibilitySettings
    });

    await graph.apolloClient.mutate({
      mutation: SAVE_STUDENT_SETTING,
      variables: {
        where: {
          setting: 'accessibility'
        },
        value: accessibilitySettings
      }
    });
  }
};
